import { forwardRef } from "react";
import { Market, UserRole } from "tm-shared/types";

import FlexContainer from "@/components/FlexContainer";
import { MarketCard } from "@/components/MarketCard";
import { useAppSelector } from "@/hooks/redux";
import { selectUncompletedTasks } from "@/store/slices/progress";

import { StyledMHWrapper } from "./Styled";

interface MarketHeaderViewProps extends React.HTMLAttributes<HTMLDivElement> {
    item: Market;
}

export const MarketHeaderView = forwardRef<
    HTMLDivElement,
    MarketHeaderViewProps
>(({ item: market, ...rest }, ref) => {
    const { role } = useAppSelector((s) => s.user);
    const uncompletedTasks = useAppSelector(selectUncompletedTasks);

    const hasDebt = role !== UserRole.Md && market?.hasDebt;

    return (
        <StyledMHWrapper
            $hasDebt={hasDebt}
            $hasUncompletedTask={uncompletedTasks?.some(
                (task) => task.marketId === market.id,
            )}
            {...rest}
            ref={ref}
        >
            <FlexContainer gap="12px" justifyContent="flex-start">
                <FlexContainer flexDirection="column" alignItems="flex-start">
                    <MarketCard
                        address={market?.address?.name}
                        fop={market?.contragent?.name}
                    />
                </FlexContainer>
            </FlexContainer>
        </StyledMHWrapper>
    );
});

MarketHeaderView.displayName = "MarketHeader";
